const url = new URL(window.location.href);
const domain = url.origin;
const body = document.getElementsByTagName("body")[0];
const headerElement = document.getElementById("header");
const headerLogo = document.getElementById("headerLogo");
const drawerElement = document.getElementById("drawer");
const drawerText = document.getElementById("drawerText");
const whiteLogoPath = `${domain}/assets/img/logo/logo-white.svg`;
const orangeLogoPath = `${domain}/assets/img/logo/logo.svg`;
const breakpoint = 768;
let logoColorChanged;

const disableScroll = (event) => {
  event.preventDefault();
};

const preventScroll = () => {
  body.style.overflow = "hidden";
  document.addEventListener("touchmove", disableScroll, { passive: false });
};

const allowScroll = () => {
  body.style.overflow = "auto";
  document.removeEventListener("touchmove", disableScroll, { passive: false });
};

const toggleDrawer = () => {
  headerElement.classList.toggle("is-open");
  headerElement.classList.add("has-transition");
  if (logoColorChanged) {
    allowScroll();
    drawerText.textContent = "Menu";
    headerLogo.src = orangeLogoPath;
    logoColorChanged = false;
  } else {
    preventScroll();
    drawerText.textContent = "Close";
    headerLogo.src = whiteLogoPath;
    logoColorChanged = true;
  }
};

const handleResize = () => {
  headerElement.classList.remove("has-transition");
  if (window.innerWidth >= breakpoint) {
    drawerText.textContent = "Menu";
    headerLogo.src = orangeLogoPath;
    headerElement.classList.remove("is-open");
    logoColorChanged = false;
    allowScroll();
  }
};

window.addEventListener("DOMContentLoaded", () => {
  drawerElement.addEventListener("click", toggleDrawer);
  window.addEventListener("resize", handleResize);

  handleResize();
});
